import { createContext, useContext, useEffect, useState } from "react";
import { http } from "../lib/api";

const ConfigCtx = createContext({ purchases_enabled: true });
export const useConfig = () => useContext(ConfigCtx);

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState({ purchases_enabled: true });
  useEffect(() => {
    http.get("/config")
      .then(({ data }) => setCfg(data))
      .catch(() => setCfg({ purchases_enabled: true })); // Fail-open — never brick the site.
  }, []);
  return <ConfigCtx.Provider value={cfg}>{children}</ConfigCtx.Provider>;
}
